<div class="area-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <span class="title">Version {{versionId}} - Shops List</span>
        </div>
        <div class="page-actions">
            <!-- <button mat-button color="primary" class="btn-add"
                (click)="addClicked()"><mat-icon>store_add</mat-icon>Assign Shop</button> -->

            <!-- <button mat-button color="accent" class="btn-export" (click)="exportClicked()" [disabled]="IsDownloading">
                <img class="download-icon"
                    [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                Export
            </button> -->
        </div>
    </div>
    <div class="data-container ">
        <app-loader [show]="isLoading"></app-loader>
        @if (isLoading) {
        <mat-icon class="loading-spinner">refresh</mat-icon>
        }

        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true"
            [hideAdvancedFilter]="true">
        </app-search-filter>
        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="shopGroup">
                    <th mat-header-cell *matHeaderCellDef colspan="3"
                        style="text-align: center; width: 180px; padding-right: 28px">
                        Shop
                    </th>
                </ng-container>
                <ng-container matColumnDef="terminalGroup">
                    <th mat-header-cell *matHeaderCellDef colspan="4"
                        style="text-align: center; width: 180px; padding-right: 28px">
                        Terminal
                    </th>
                </ng-container>
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef class="item-header">#</th>
                    <td mat-cell *matCellDef="let shop; let i = index" class="item-column">{{
                        (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                </ng-container>

                <ng-container matColumnDef="shopCode">
                    <th mat-sort-header="shopCode" mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let shop">
                        <button mat-button color="primary" class="btn-view-shops"
                            (click)="onShopCodeClick(shop); $event.stopPropagation();">
                            {{shop.shopCode}}
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="shopName">
                    <th mat-sort-header="shopName" mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let shop">
                        <span class="shop-name">{{shop.shopName}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="totalTerminals">
                    <th mat-sort-header="totalTerminals" mat-header-cell *matHeaderCellDef style="width: 5%;">Total</th>
                    <td mat-cell *matCellDef="let shop" style="text-align: center;">
                        <span class="terminal-count">{{shop.totalTerminals}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="assignedTerminals">
                    <th mat-sort-header="assignedTerminals" mat-header-cell *matHeaderCellDef style="width: 5%;">
                        Assigned</th>
                    <td mat-cell *matCellDef="let shop" style="text-align: center;">
                        <span class="terminal-count assigned">{{shop.assignedTerminals}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="updatedTerminals">
                    <th mat-sort-header="updatedTerminals" mat-header-cell *matHeaderCellDef style="width: 5%;">Updated
                    </th>
                    <td mat-cell *matCellDef="let shop" style="text-align: center;">
                        <span class="terminal-count updated" [ngClass]="{'fully-updated': shop.updatedTerminals === shop.assignedTerminals, 
                                           'partially-updated': shop.updatedTerminals > 0 && shop.updatedTerminals < shop.assignedTerminals,
                                           'not-updated': shop.updatedTerminals === 0}">
                            {{shop.updatedTerminals}}
                        </span>
                        <!-- <mat-icon class="status-icon" 
                                [ngClass]="{'success-icon': shop.hasUpdates, 'error-icon': !shop.hasUpdates}"
                                [matTooltip]="shop.hasUpdates ? 'Fully updated' : 'Not fully updated'">
                                {{shop.hasUpdates ? 'check_circle' : 'cancel'}}
                            </mat-icon> -->
                    </td>
                </ng-container>

                <!-- <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let shop">
                        <div class="updated-terminals-cell">
                            <mat-icon class="status-icon"
                                [ngClass]="{'success-icon': shop.hasUpdates, 'error-icon': !shop.hasUpdates}"
                                [matTooltip]="shop.hasUpdates ? 'Fully updated' : 'Not fully updated'">
                                {{shop.hasUpdates ? 'check_circle' : 'cancel'}}
                            </mat-icon>
                        </div>
                    </td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="topHeaderRow; sticky: true"></tr>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                </tr>
                <tr mat-row class="table-element-row" *matRowDef="let shop; columns: displayedColumns;"
                    (click)="onRowSelected(shop)" [ngClass]=" {'row-selected' : shop.shop_id===selectedItem?.shop_id}">
                </tr>
            </table>
        </section>

        <!-- </ng-container> -->
        <!-- <ng-template #nodata> -->
        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found. Please remove or redefine the filters if
                any.</span>
    </div>
    <!-- </ng-template> -->
    }
</div>

</div>